/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IIndustryFocusDataState } from "../../Interfaces/SiteContent";
import { IGetIndustryFocusFailure, IGetIndustryFocusSuccess } from "./IndustryFocusAction";
import {
  INDUSTRY_FOCUS_LOAD_FAILURE,
  INDUSTRY_FOCUS_LOAD_SUCCESS,
} from "./IndustryFocusActionTypes";

const initialState: IIndustryFocusDataState = {
  industryFocuses: [],
  industryFocusesOptionList: [],
  industryFocusLoadError: "",
};

/**
 * Updates state of fetch industry focuses success.
 * @param {IIndustryFocusDataState} state The industry focus state.
 * @param {IGetIndustryFocusSuccess} action The industry focus action success.
 * @returns {IIndustryFocusDataState} New industry focus state.
 */
const applyLoadIndustryFocuses = (
  state: IIndustryFocusDataState,
  action: IGetIndustryFocusSuccess
): IIndustryFocusDataState => ({
  ...state,
  industryFocuses: action.industryFocuses,
  industryFocusesOptionList: action.industryFocuses.map((x) => ({
    key: x.text,
    text: x.industryFocusLocKey,
  })),
});

/**
 * Updates state of fetch industry focuses failure.
 * @param {IIndustryFocusDataState} state The industry focus state.
 * @param {IGetIndustryFocusFailure} action The industry focus action failure.
 * @returns {IIndustryFocusDataState} New industry focus state.
 */
const applyLoadFailIndustryFocuses = (
  state: IIndustryFocusDataState,
  action: IGetIndustryFocusFailure
): IIndustryFocusDataState => ({
  ...state,
  industryFocusLoadError: action.industryFocusLoadError,
});

/**
 * Reducer function for Activity component.
 * @param {IIndustryFocusDataState} state The activity state.
 * @param {IndustryFocusActionTypes} action The action type.
 * @returns {IIndustryFocusDataState} The activity state.
 */

function industryFocusReducer(
  state: IIndustryFocusDataState = initialState,
  action
): IIndustryFocusDataState {
  switch (action.type) {
    case INDUSTRY_FOCUS_LOAD_SUCCESS:
      return applyLoadIndustryFocuses(state, action);
    case INDUSTRY_FOCUS_LOAD_FAILURE:
      return applyLoadFailIndustryFocuses(state, action);
    default:
      return state;
  }
}

export default industryFocusReducer;
